<dialog-draggable-header>Add Comment</dialog-draggable-header>

<mat-dialog-content>
  <form [formGroup]="form" class="container">
    <div class="row">
      <mat-form-field class="col">
        <mat-label>Comment</mat-label>
        <textarea id="comment" matInput formControlName="comment" maxLength="400"></textarea>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions  class="mat-dialog-actions-end no-margin">
  <button mat-raised-button [disabled]="form.invalid" color="primary" (click)="save()">Save</button>
  <button mat-raised-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>